
export class LOVConventionGenderExtension {
}
